<template>
  <div>
    <v-layout row wrap align-center>
      <v-flex xs12 class="text-xs-center">
        <h1 class="display-1">Thank you!</h1>
      </v-flex>
    </v-layout>
    <v-layout class="mt-5">
      <v-container grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12 md8 offset-md2>
            <p>
              Please check your email for details regarding this purchase. Further instructions, 
              if any, will be provided within the email.
            </p>
            <p>Thank you for your business.</p>
            <p class="text-xs-center">
              <v-btn outline color="primary" @click.native="visitMyAccount">
                Visit my account
              </v-btn>
            </p>
          </v-flex>
        </v-layout>
      </v-container>  
    </v-layout>    
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    async visitMyAccount() {
      await this.$store.dispatch("clearDetails");
      this.$store.dispatch("visitMyAccount");
      // this.$router.push({ name: 'verify-pin' })
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/billing/Confirmation.vue